import React, { useState } from "react";
import CertificationLayout from "../../../sections/BusinessDashboard/Certifications/CertificationLayout";
import DashboardMainContainer from "../../../components/common/Containers/DashboardMainContainer";
import Agreement from "./CertificationPopUp/Agreement";

const Certifications = () => {
  const [agreementDocs, setAgreementDocs] = useState(true);
  return (
    <>
      {agreementDocs ? (
        <>
          <Agreement clickHandler={() => setAgreementDocs(false)} />
        </>
      ) : (
        <>
          <DashboardMainContainer className="!bg-white min-w-0">
            {/* <Heading variant={"h6"} className={"text-center text-offblack"}>
            Badges
            </Heading> */}
            <div className="flex justify-center min-h-screen w-full min-w-0">
              <CertificationLayout />
            </div>
          </DashboardMainContainer>
        </>
      )}
    </>
  );
};

export default Certifications;
